import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Table } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import { formatDateTimeFromApi } from "../utils/dateTime";
import AddEditBot from "../bot/AddEditBot";
import { ExchangeType } from "../constants";
import AddExchangeAccount from "./AddExchangeAccount";
import { id2BgColor } from "../utils/colorUtils";

@inject("store")
@observer
class ExchangeAccounts extends Component {
  state = {
    exchangeAccounts: null,
    addExchangeAccount: null,
    addBot: false,
    shortId: true,
    shortApiKey: true,
  };

  constructor() {
    super();
    this.load = this.load.bind(this);
  }

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  async load() {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
        params: {
          withDisabled: this.state.withDisabled,
          withOthers: this.state.withOthers,
        },
      });

      let response = await axiosRequest.get("exchangeAccount/list");
      // console.log('exchangeAccount/list response', response);
      this.setState({ exchangeAccounts: response.data });
    } finally {
      this.setState({ loading: false });
    }
  }

  AddExchangeAccountButton = ({ exchangeType }) => (
    <Button
      icon="add"
      content={`Add ${exchangeType}`}
      onClick={() => this.setState({ addExchangeAccount: { exchange: exchangeType } })}
    />
  );

  EditExchangeAccountButton = ({ exchangeAccount }) => (
    <Button
      basic
      size="small"
      icon="edit"
      title="Edit"
      onClick={() => this.setState({ addExchangeAccount: exchangeAccount })}
      disabled={Boolean(this.state.addExchangeAccount)}
    />
  );

  BalanceButton = ({ exchangeAccount }) => (
    <Button
      basic
      size="small"
      icon="chart line"
      title="Balance"
      onClick={() => this.props.history.push(`/exchange-account/${exchangeAccount.id}/balance`)}
      disabled={Boolean(this.state.addExchangeAccount || this.state.addBot)}
    />
  );

  render() {
    const { AddExchangeAccountButton, EditExchangeAccountButton, BalanceButton } = this;
    const { addExchangeAccount } = this.state;
    const {
      store: { zoneId },
    } = this.props;

    return (
      <div>
        <h1>Exchange Accounts</h1>
        <Table unstackable collapsing>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell
                onClick={() => this.setState({ shortId: !this.state.shortId })}
                style={{
                  cursor: "pointer",
                }}
              >
                ID
              </Table.HeaderCell>
              <Table.HeaderCell>Exchange</Table.HeaderCell>
              <Table.HeaderCell
                onClick={() => this.setState({ shortApiKey: !this.state.shortApiKey })}
                style={{
                  cursor: "pointer",
                }}
              >
                API Key
              </Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Created At</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.exchangeAccounts &&
              this.state.exchangeAccounts.map(ea => (
                <Table.Row key={ea.id} style={{ whiteSpace: "nowrap" }} active={ea.id === this.state.selectedId}>
                  <Table.Cell>
                    <EditExchangeAccountButton exchangeAccount={ea} />
                    <BalanceButton exchangeAccount={ea}/>
                  </Table.Cell>
                  <Table.Cell title={ea.id}>{this.state.shortId ? ea.id.substring(0, 4) : ea.id}</Table.Cell>
                  <Table.Cell style={{ backgroundColor: id2BgColor(ea.exchange) }}>{ea.exchange}</Table.Cell>
                  <Table.Cell title={ea.credentialsEnc}>
                    <code>
                      {this.state.shortApiKey ? ea.credentialsEnc.substring(0, 8).concat("...") : ea.credentialsEnc}
                    </code>
                  </Table.Cell>
                  <Table.Cell>
                    <strong>{ea.name}</strong>
                  </Table.Cell>
                  <Table.Cell>{formatDateTimeFromApi(ea.createdAt, zoneId)}</Table.Cell>
                  <Table.Cell>
                    {!addExchangeAccount &&
                      !this.state.addBot && (
                        <Button
                          icon="add"
                          content="Add Bot"
                          onClick={() => this.setState({ addBot: true, selectedId: ea.id })}
                        />
                      )}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
        <Button.Group>
          <Button content="Refresh" icon="refresh" onClick={this.load} loading={this.state.loading} />
        </Button.Group>
        &nbsp;
        {!addExchangeAccount &&
          !this.state.addBot && (
            <Fragment>
              {Object.values(ExchangeType).map(exchangeType => (
                <AddExchangeAccountButton key={exchangeType} exchangeType={exchangeType} />
              ))}
            </Fragment>
          )}
        {addExchangeAccount && (
          <AddExchangeAccount
            exchangeAccount={addExchangeAccount}
            onSuccess={() => {
              this.setState({ addExchangeAccount: null });
              this.load();
            }}
            onClose={() => this.setState({ addExchangeAccount: null })}
          />
        )}
        {this.state.addBot && (
          <AddEditBot
            exchangeAccountId={this.state.selectedId}
            onSuccess={() => {
              this.setState({ addBot: false, selectedId: null });
              this.load();
            }}
            onClose={() => this.setState({ addBot: false, selectedId: null })}
          />
        )}
      </div>
    );
  }
}

export default ExchangeAccounts;



// WEBPACK FOOTER //
// ./src/exchangeAccounts/ExchangeAccounts.js